import * as React from 'react';
import Layout from '../Layout/Layout';
import Title from '../shared/Title/Title';
import ContactForm from './ContactForm/ContactForm';
import { connect, Dispatch } from 'react-redux';
import { AscendState } from '../../ducks';
import { CONTACT_SUBMIT } from '../../ducks/actions';
import Paper from '@material-ui/core/Paper/Paper';
import Grid from '@material-ui/core/Grid/Grid';
import Typography from '@material-ui/core/Typography/Typography';
import withTheme, { WithTheme } from '@material-ui/core/styles/withTheme';

interface ContactProps {
  name: string;
  email: string;
  contactMessageSubmitted: boolean;
  submitContact: (message: string) => void;
}

const Contact = ({
  theme,
  name,
  email,
  contactMessageSubmitted,
  submitContact,
}: ContactProps & WithTheme) => (
  <Layout>
    <div>
      <Title text="Contact Us" />
      {!contactMessageSubmitted ? (
        <ContactForm
          initialValues={{ name, email }}
          onSubmit={(data: { message: string }) => submitContact(data.message)}
        />
      ) : (
        <Grid container alignItems="center" justify="center">
          <Grid item xs={11} container alignItems="center" justify="center">
            <Paper
              style={{
                width: '100%',
                padding: '15px',
                backgroundColor: theme.palette.primary.light,
                color: theme.palette.primary.contrastText,
              }}>
              <Typography variant="display1" align="center" color="inherit" gutterBottom>
                Success!
              </Typography>
              <Typography variant="subheading" align="center" color="inherit" paragraph>
                You have successfully submitted your contact message, and we will respond to you
                through email promptly!
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      )}
    </div>
  </Layout>
);

const mapStateToProps = (state: AscendState) => ({
  name: `${state.user.data.firstName} ${state.user.data.lastName}`,
  email: state.user.data.email,
  contactMessageSubmitted: state.user.contactMessageSubmitted,
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
  submitContact: (message: string) => dispatch({ type: CONTACT_SUBMIT, message }),
});
export default withTheme()(
  connect(
    mapStateToProps,
    mapDispatchToProps
    // @ts-ignore
  )(Contact)
);
